<template>
  <div
    class="image-text-nav"
    :class="{shadow: $$FormData.box_shadow}"
    :style="{
      marginLeft: ($$FormData.page_edge ) * 0.5 + 'px',
      marginRight: ($$FormData.page_edge ) * 0.5 + 'px',
      paddingTop: ($$FormData.vertical_padding ) * 0.5 + 'px',
      paddingBottom: ($$FormData.vertical_padding ) * 0.5 + 'px',
      borderRadius: ($$FormData.block_radius ) * 0.5 + 'px',
      backgroundColor: $$FormData.background_color,
    }"
  >
    <div v-if="$$FormData.nav_title" class="image-text-nav_title">
      <div class="image-text-nav_title__text">{{ $$FormData.nav_title }}</div>
      <div v-if="$$FormData.nav_title_more" class="image-text-nav_title__more">{{ $$FormData.nav_title_more }}</div>
    </div>
    <div
      v-if="$$FormData.navList.length"
      class="image-text-nav__nav"
      :class="[$$FormData.nav_type]"
      :style="{
        overflowX: $$FormData.nav_style === 'scroll' ? 'auto' : 'hidden',
      }"
    >
      <div
        v-for="item in $$FormData.navList"
        :key="item.__key"
        class="image-text-nav__item"
        :style="{
          width: (itemSize ) * 0.5 + 'px',
          color: $$FormData.text_color
        }"
      >
        <div
          v-if="$$FormData.nav_type === 'image-text'"
          class="image-text-nav__image"
          :style="{
            width: (itemSize * $$FormData.image_scale ) * 0.5 + 'px',
            height: (itemSize * $$FormData.image_scale ) * 0.5 + 'px',
            backgroundImage: `url(${item.image.src || default_image})`,
            borderRadius: ($$FormData.image_radius ) * 0.5 + 'px',
          }"
        />
        <h3 v-if="item.title" class="image-text-nav__title">{{ item.title }}</h3>
      </div>
    </div>
    <div v-else class="image-text-nav__empty">
      请添加导航
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageTextNavPreview',
  data() {
    return {
      default_image: require('@/assets/placeholder-image-text-nav-image.png')
    }
  },
  computed: {
    itemSize() {
      const {navList, nav_style, page_edge, nav_show_num} = this.$$FormData
      if (nav_style === 'fixed') return `${(750 - page_edge * 2) / navList.length}`
      return `${(750 - page_edge * 2) / nav_show_num}`
    }
  }
}
</script>

<style lang="scss" scoped>
.image-text-nav {
  overflow: hidden;
  &.shadow {
    box-shadow: 0 4px 10px 0 rgba(175, 175, 175, 0.3);
  }
  &_title {
    display: flex;
    justify-content: space-between;
    padding: 0 12px;
    margin-bottom: 12px;
    &__text {
      position: relative;
      color: #3e64e9;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 12px;
      padding-left: 10px;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        width: 5px;
        height: 14px;
        background-color: #3e64e9;
        border-radius: 5000px;
      }
    }
    &__more {
      color: #666666;
      font-size: 13px;
    }
  }
  &__nav {
    display: flex;
    flex-wrap: wrap;
    row-gap: 10px;
    margin-bottom: -10px;
    padding-bottom: 10px;
    -webkit-overflow-scrolling: touch;
  }
  &__item {
    display: inline-block;
    overflow: hidden;
  }
  &__image {
    display: block;
    width: 100%;
    margin: 0 auto;
    border: 0;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center center;
  }
  &__title {
    box-sizing: border-box;
    overflow: hidden;
    width: 100%;
    margin-top: 5px;
    font-size: 12px;
    line-height: normal;
    text-align: center;
  }
  &__empty {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    color: #7d7d80;
    font-size: 18px;
    background-color: #909399;
  }
}
</style>
